import axios from "axios";
import ConstantList from "../../../appConfig";
const API_PATH = ConstantList.API_ENPOINT + "/api/etb/treatment-book";

export const getEtbTreatmentBookDtoByPatientId= (id) => {
  let url = API_PATH + "/get-treatment-book/" + id;
  return axios.get(url);
};
export const getEtbTreatmentBookDetailDto= (id) => {
    let url = API_PATH + "/get-treatment-book-detail/" + id;
    return axios.get(url);
  };

export const createEtbTreatmentBookDetailDto = (obj) => {
  let url = API_PATH;
  return axios.post(url, obj);
};

export const editEtbTreatmentBookDetailDto = (obj,id) => {
  let url = API_PATH + "/" + id;
  return axios.put(url, obj);
};

export const getListEpisodeOfCareBy = (obj) => {
  let url = API_PATH + "/search-by";
  return axios.post(url, obj);
};

export const checkDotThuoc = (id) => {
  let url = API_PATH + "/check-dot-thuoc/" + id;
  return axios.get(url);
};

export const getEtbByPatientId = (id) => {
  let url = API_PATH + "/get-etb-by-patient-id/" + id;
  return axios.get(url);
};

export const checkValidatePeriod = (obj) => {
  let url = API_PATH + "/checkValidatePeriod";
  return axios.post(url, obj);
};



